import { getWalletIcon, walletList, zkLoginList } from '@constants/wallet-list';
import { walletConnectModel } from '@models/wallet-connect.model';
import { useConnectWallet, useDisconnectWallet, useWallets } from '@mysten/dapp-kit';
import { useModel } from 'foca';
import { type FC } from 'react';
import CoinLogo from '@ui/coin-logo';
import { toast } from 'react-toastify';
import styles from './wallet-dialog.module.scss';
import Dialog from '@ui/parrot/dialog';

const WalletDialog: FC = () => {
  const wallets = useWallets();
  const { mutate: connect } = useConnectWallet();
  const { mutate: disconnect } = useDisconnectWallet();
  const showDialog = useModel(walletConnectModel, (state) => state.openDialog);

  return (
    <Dialog
      isShown={showDialog}
      width={360}
      title="Connect a Wallet"
      onCloseComplete={walletConnectModel.toggleDialog}
    >
      {({ close }: { close: () => void }) => (
        <div className={styles.wallet_list}>
          <div className={styles.wallet_right}>
            <ul>
              {zkLoginList
                .filter((item) => !item.hidden)
                .map((item) => {
                  const wallet = wallets.find((wallet) => wallet.name === item.walletName);
                  return (
                    <li
                      key={item.label}
                      onClick={() => {
                        walletConnectModel.toggleDialog();
                        if (wallet) {
                          disconnect();
                          connect({
                            wallet,
                          });
                        } else {
                          toast(
                            <>
                              <p>Wallet is not ready, please install extension first</p>
                            </>,
                            {
                              type: 'error',
                            },
                          );
                        }
                      }}
                    >
                      <div className={styles.list}>
                        <div className={styles.icon}>
                          <CoinLogo src={getWalletIcon(item.iconName)} />
                        </div>
                        <span>{item.label}</span>
                      </div>
                    </li>
                  );
                })}
            </ul>
          </div>

          <div className={styles.wallet_left}>
            <ul>
              {walletList
                .filter((item) => !item.hidden)
                .map((item) => {
                  const wallet = wallets.find((wallet) => wallet.name === item.walletName);
                  return (
                    <li
                      key={item.walletName}
                      onClick={() => {
                        close();
                        if (wallet) {
                          disconnect();
                          connect({
                            wallet,
                          });
                        } else {
                          toast(
                            <>
                              <p>
                                Wallet is not ready, please install&nbsp;
                                <a href={item.chromeExtension} target="_blank">
                                  {item.walletName}
                                </a>
                                &nbsp; extension first
                              </p>
                            </>,
                            {
                              type: 'error',
                            },
                          );
                        }
                      }}
                    >
                      <CoinLogo src={getWalletIcon(item.iconName) || wallet?.icon} />
                      <span>{item.label}</span>
                      {wallet ? null : 'Install'}
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      )}
    </Dialog>
  );
};

export default WalletDialog;
